import {ChangeDetectionStrategy, Component, input} from '@angular/core';
import {AppNumberPipe} from '@frontend/shared';
import {TranslocoPipe} from '@jsverse/transloco';
import {ScoreBarComponent} from '../../../score-bar/score-bar.component';
import {RfpSubCriterionResult} from '../../rfp-individual-results.types';

@Component({
  selector: 'app-rfp-highlight-list',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [AppNumberPipe, TranslocoPipe, ScoreBarComponent],
  host: {class: 'card flex flex-col gap-3 p-4'},
  templateUrl: './rfp-highlight-list.component.html',
})
export class RfpHighlightListComponent {
  readonly titleKey = input.required<string>();
  readonly icon = input.required<string>();
  readonly items = input.required<RfpSubCriterionResult[]>();
}
